export const DEFAULT_DATE = new Date();
export const DEFAULT_DATE_OUTPUT_FORMAT = "dd MMM yyyy"